import React from "react";
import MobileActive from "../../assets/images/mobileActive.svg";
import MonitorActive from "../../assets/images/monitorActive.svg";

export const ViewMode = ({
  mobileView,
  onClick,
  setForegroundColor,
  saveAsBlock,
}) => {
  if (mobileView & !saveAsBlock) {
    return (
      <div
        onClick={onClick}
        style={{
          color: "#26a9e1",
          position: "fixed",
          top: "20px",
          right: "35px",
          display: "flex",
          cursor: "pointer",
          fontFamily: "Montserrat",
        }}
      >
        <img
          style={{
            height: "20px",
            width: "20px",
            marginRight: "5px",
          }}
          src={MobileActive}
        />
        Editing Mobile View...
      </div>
    );
  } else if (!mobileView & !saveAsBlock) {
    return (
      <div
        className="editingDesktop"
        onClick={onClick}
        style={{
          color: "#26a9e1",
          marginLeft: "5px",
          marginTop: "2px",
          zIndex: 45,
          cursor: "pointer",
          color: setForegroundColor(),
          fontFamily: "Montserrat",
        }}
      >
        <img
          className="editingDesktop-image"
          style={{
            height: "20px",
            width: "20px",
            marginRight: "7px",
            marginBottom: "5px",
            marginTop: "2px",
          }}
          src={MonitorActive}
        />
        <p
          className="editingDesktop-text"
          style={{ marginTop: "3px", color: setForegroundColor() }}
        >
          Editing Desktop View...
        </p>
      </div>
    );
  }
};
